import React from 'react';
import { Typography, Box } from '@mui/material';
import { GridItem } from '../../../components/shared';
import { PerformantCollectionTextField } from './PerformantCollectionTextField';

import { getIntercardFieldName } from '../../../utils/collection-methods';
import { FIELD_NAME } from '../../../constants/MeterTypeFieldMap';
import { isArrayWithLength } from '../../../utils/common-methods';
import useStyles from '../style';

const IntercardFields = ({ intercardTransactions, assetId, sublocationId }) => {
  const classes = useStyles();

  const intercardItems = [
    {
      fieldName: FIELD_NAME.STANDARD_PLAY,
      label: 'Standard Play',
      disabled: true,
    },
    {
      fieldName: FIELD_NAME.CASH_DEBITS,
      label: 'Cash Debits',
      disabled: true,
    },
    {
      fieldName: FIELD_NAME.POINTS,
      label: 'Points',
      disabled: true,
    },
  ];

  if (intercardTransactions && isArrayWithLength(intercardTransactions)) {
    return (
      <React.Fragment>
        {intercardTransactions?.map((transaction, i) => {
          const meterLabel = transaction?.assetSubTag || 'Intercard';
          const fieldsToRender = intercardItems.slice(0, 3);

          return (
            <GridItem sm={12} md={12} px={0} pt={0.25} key={i}>
              <Box className={classes.compactMeterRow}>
                <Box className={classes.compactMeterLabelWrap}>
                  <Typography variant="subtitle4" className={classes.compactMeterLabel}>
                    {meterLabel}
                  </Typography>
                </Box>
                <Box
                  className={classes.compactMeterGrid}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${fieldsToRender.length}, 1fr)`,
                  }}
                >
                  {fieldsToRender.map((field, index) => {
                    let fieldLabel = field.label;
                    if (field.fieldName === FIELD_NAME.POINTS && transaction[FIELD_NAME.GROUP]) {
                      fieldLabel = `${fieldLabel}(${transaction[FIELD_NAME.GROUP]})`;
                    }
                    const fieldName = getIntercardFieldName(
                      assetId,
                      transaction?.assetSubTag,
                      sublocationId,
                      field.fieldName,
                      transaction?.group,
                    );

                    return (
                      <div key={index} className={classes.compactFieldCell}>
                        <PerformantCollectionTextField
                          type="number"
                          label={fieldLabel}
                          name={fieldName}
                          customizedError={false}
                          disabled={field.disabled}
                        />
                      </div>
                    );
                  })}
                </Box>
              </Box>
            </GridItem>
          );
        })}
      </React.Fragment>
    );
  }
  return;
};

export default IntercardFields;
